import React, { useEffect, useState } from 'react';
import { Mail, Star } from 'lucide-react';
import { leadership as fallback } from '../mock';
import { useLang } from '../i18n/LanguageContext';
import { api } from '../services/api';
import HutRiWatermark from '../components/HutRiWatermark';

const Leadership = () => {
  const { t, tv, lang } = useLang();
  const [list, setList] = useState(fallback);

  useEffect(() => {
    api.listLeadership().then((d) => { if (d && d.length) setList(d); }).catch(() => {});
  }, []);

  return (
    <>
      <div className="relative h-[320px] bg-[#0a1929] overflow-hidden">
        <img src="https://images.unsplash.com/photo-1590844173529-8a303db29cd0" alt="" className="absolute inset-0 w-full h-full object-cover opacity-30" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0a1929]/60 to-[#0a1929]" />
        <HutRiWatermark size="md" />
        <div className="relative max-w-7xl mx-auto px-4 h-full flex flex-col justify-end pb-10">
          <div className="h-[3px] w-16 bg-[#d4a017] mb-3" />
          <div className="text-[#d4a017] text-xs tracking-[0.3em] uppercase mb-2">{lang === 'id' ? 'Pengurus Yayasan' : 'Foundation Leadership'}</div>
          <h1 className="text-white text-5xl md:text-6xl font-bold tracking-wide" style={{ fontFamily: "'Roboto Condensed', sans-serif" }}>{t('leadership')}</h1>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-16 space-y-14">
        {list.map((p, i) => (
          <div key={p.id || p.name} className={`grid md:grid-cols-5 gap-8 items-center ${i % 2 ? 'md:[direction:rtl]' : ''}`}>
            <div className="md:col-span-2 [direction:ltr]">
              <div className="relative aspect-[4/5] overflow-hidden bg-[#0a1929] shadow-2xl">
                <img src={p.image} alt={p.name} className="w-full h-full object-cover" />
                <div className="absolute bottom-0 left-0 right-0 h-2 bg-gradient-to-r from-[#b8860b] via-[#d4a017] to-[#b8860b]" />
              </div>
            </div>
            <div className="md:col-span-3 [direction:ltr]">
              <div className="flex items-center gap-2 mb-3">
                {[...Array(4)].map((_, k) => <Star key={k} size={16} className="fill-[#d4a017] text-[#d4a017]" />)}
              </div>
              <div className="text-[#d4a017] text-xs tracking-[0.3em] uppercase mb-2">{tv(p.title)}</div>
              <h2 className="text-4xl md:text-5xl font-bold text-[#0a1929] mb-5 tracking-wide" style={{ fontFamily: "'Roboto Condensed', sans-serif" }}>{p.name}</h2>
              <p className="text-gray-700 leading-relaxed mb-5">{tv(p.bio) || (lang === 'id' ? 'Biografi lengkap akan segera tersedia.' : 'Full biography coming soon.')}</p>
              <a href="#" className="inline-flex items-center gap-2 border-2 border-[#0a1929] text-[#0a1929] hover:bg-[#0a1929] hover:text-white font-bold px-6 py-2.5 tracking-widest uppercase text-xs transition">
                <Mail size={14} /> {t('fullBio')}
              </a>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default Leadership;
